export default __webpack_public_path__ + "static/the-salty-sketch-ca6115d35ac410f7a28912bdc8fdd4d3.png";